import React, { useEffect } from 'react';

const HubspotForm = ({ scriptSrc, formId }) => {
  const isEmbedScript = scriptSrc.includes('/forms/embed/');

  useEffect(() => {
    const script = document.createElement('script');
    script.src = scriptSrc;
    script.defer = true;

    script.onerror = () => {
      console.error('HubSpot script failed to load');
    };

    document.body.appendChild(script);

    if (!isEmbedScript) {
      script.addEventListener('load', () => {
        if (window.hbspt) {
          console.log('Using HubSpot v2 API to create form');
          window.hbspt.forms.create({
            region: 'na1',
            portalId: '6129878',
            formId: formId,
            target: '#hubspotForm',
          });
        } else {
          console.error('window.hbspt is not available');
        }
      });
    } else {
      console.log('Using HubSpot embed script (auto-inject)');
    }

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [scriptSrc, formId]);

  return (
    <div>
      {isEmbedScript ? (
        <div
          className="hs-form-frame"
          data-region="na1"
          data-form-id={formId}
          data-portal-id="6129878"
        />
      ) : (
        <div id="hubspotForm"></div>
      )}
    </div>
  );
};

export default HubspotForm;
